import NavIcon from "./NavIcon";

export default function StaffIcon(props) {
  return (
    <NavIcon {...props}>
      <rect x="2" y="3" width="20" height="18" rx="3" />
      <circle cx="12" cy="10" r="3" />
      <path d="M7 21v-1a5 5 0 0110 0v1" />
    </NavIcon>
  );
}
